"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CSVInput = {
    type: "structure",
    required: [],
    members: {
        FileHeaderInfo: {
            shape: {
                type: "string"
            }
        },
        Comments: {
            shape: {
                type: "string"
            }
        },
        QuoteEscapeCharacter: {
            shape: {
                type: "string"
            }
        },
        RecordDelimiter: {
            shape: {
                type: "string"
            }
        },
        FieldDelimiter: {
            shape: {
                type: "string"
            }
        },
        QuoteCharacter: {
            shape: {
                type: "string"
            }
        },
        AllowQuotedRecordDelimiter: {
            shape: {
                type: "boolean"
            }
        }
    }
};
//# sourceMappingURL=_CSVInput.js.map